<template>
  <div>
    <a-select
      mode="multiple"
      style="width: 360px;margin-left:20px;"
      placeholder="请选择课文"
      option-label-prop="label"
      @change="getBook"
      showSearch
      allowClear
    >
      <a-select-option :value="item.id" :label="item.title" v-for="item in value" :key="item.id">
        {{item.title}}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: ''
    }
  },
  mounted () {
    console.log('getMess', this.value)
  },
  methods: {
    getBook (e) {
      let checkBookList = ''
      checkBookList += e + ','
      // 获取课文id值
      checkBookList = checkBookList.slice(0, checkBookList.length - 1)
      this.$emit('getMess', checkBookList)
    }
  }
}
</script>

<style lang="less" scoped>
  // /deep/.ant-select-selection{
  //   border: none;
  //   background: #f2f5f5;
  // }
</style>
